export enum batchNotificationInterval {
  tenPercent = "tenPercent",
  fiftyPercent = "fiftyPercent",
  hundredPercent = "hundredPercent",
}
